export const TIME_PATTERN = /^([0-1]{0,1}[0-9]{1}):([0-9]{2})([aApP]{1})[mM]/;
const TIME_PATTERN24 = /^([0-2]?[0-9]):([0-5][0-9])/;
const TIME_PATTERN12 = /^([0-1]?[0-9]):([0-5][0-9])([aApP])[mM]/;
export const DATE_PATTERN = /^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})/;
export function padZero(number: Number | string) {
  return ("0" + number).slice(-2);
}

const AM_PM = ["am", "pm"];
const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const MINUTES = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
export const TIME_VALUES: string[] = getTimeValuesForTimePicker();

function getTimeValuesForTimePicker() {
  let timeValues = [];
  for (const ap of AM_PM) {
    for (const hour of HOURS) {
      for (const minute of MINUTES) {
        timeValues.push(`${hour}:${padZero(minute)}${ap}`);
      }
    }
  }
  return timeValues;
}

export function from24To12String(value24: string) {
  const [h, m] = value24.split(":");
  let hours = parseInt(h, 10);
  let minutes = parseInt(m, 10);
  if (isNaN(hours) || isNaN(minutes)) throw "invalid 24h format";

  let ampm = "am";
  if (hours === 0) hours = 12;

  if (hours >= 12) {
    if (hours > 12) {
      hours = hours - 12;
    }
    ampm = "pm";
  }

  return `${hours}:${padZero(minutes)}${ampm}`;
}

export function from12To24String(value12: string) {
  const v = value12.match(TIME_PATTERN);
  if (v) {
    const hPart = parseInt(v[1], 10);
    const h = v[3].toLowerCase() === "p" ? padZero(hPart === 12 ? hPart : hPart + 12) : padZero(hPart === 12 ? 0 : hPart);
    const minutes = v[2];
    return `${h}:${minutes}`;
  }

  throw "wrong 12h format";
}

export function validate24Time(value: string): boolean {
  return !!value.match(TIME_PATTERN24);
}

export function validate12Time(value: string): boolean {
  return !!value.match(TIME_PATTERN12);
}

export function validateDateString(dateStr: string) {
  const date = dateStr.match(DATE_PATTERN);
  if (date) {
    const [_, yearStr, monthStr, dayStr] = date;
    const year = parseInt(yearStr);
    const month = parseInt(monthStr);
    const day = parseInt(dayStr);
    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      try {
        const d = new Date(year, month - 1, day);
        return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day;
      } catch {
        return false;
      }
    }
  }
  return false;
}
